<script>
export default {
  name: 'PreviewScreen',
  props: {
    logo: {
      type: String
    },
    backgroundColor: {
      type: String,
      default: '#FAFAFA'
    },
    primaryColor: {
      type: String,
      default: '#222222'
    },
    secondaryColor: {
      type: String,
      default: '#15BBF0'
    }
  },
  data () {
    return {
      primaryTextColor: '#222222',
      splashTextColor: '#000000'
    }
  },
  watch: {
    backgroundColor: {
      immediate: true,
      handler (newVal) {
        this.splashTextColor = this.isDarkColor(newVal) ? '#FFFFFF' : '#000000'
      }
    },
    primaryColor: {
      immediate: true,
      handler (newVal) {
        this.primaryTextColor = this.isDarkColor(newVal) ? '#FFFFFF' : '#222222'
      }
    }
  },
  methods: {
    isDarkColor (color) {
      const c = color.substring(1) // strip #
      const rgb = parseInt(c, 16) // convert rrggbb to decimal
      const r = (rgb >> 16) & 0xff // extract red
      const g = (rgb >> 8) & 0xff // extract green
      const b = (rgb >> 0) & 0xff // extract blue
      const luma = 0.2126 * r + 0.7152 * g + 0.0722 * b // per ITU-R BT.709
      return luma < 128
    }
  }
}
</script>

<template>
  <div>
    <slot
      :logo="logo"
      :backgroundColor="backgroundColor"
      :primaryColor="primaryColor"
      :secondaryColor="secondaryColor"
      :primaryTextColor="primaryTextColor"
      :splashTextColor="splashTextColor"
    ></slot>
  </div>
</template>
